import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import WarningIcon from '@mui/icons-material/Warning';

function ChangingDefaultPresetsInfo() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '6px',
        height: '55px',
        gap: '20px',
        backgroundColor: 'gray.chrome',
        px: '24px',
        mr: '24px',
        mt: '24px',
      }}
    >
      <WarningIcon color="textLight" />
      <Typography variant="body1">
        <Trans i18nKey="mediaPlanning.defaultPresetsChange" />
      </Typography>
    </Box>
  );
}

export default ChangingDefaultPresetsInfo;
